<div class="tc-card br-card">
  <header class="tc-toolbar">
    <h2 class="tc-title">Roles</h2>

    <div class="tc-search">
      <br-icon class="tc-search-icon">search</br-icon>
      <input type="search" autocomplete="off" placeholder="Search" [(ngModel)]="search" />
    </div>

    <button type="button" class="br-btn br-btn--primary" *ngIf="auth.hasPermission('Role.Manage')" (click)="createRole()">
      <br-icon>add</br-icon> New role
    </button>
  </header>

  <div class="tc-table-wrap">
    <table class="tc-table" *ngIf="filtered.length">
      <thead>
        <tr>
          <th>Name</th>
          <th class="num">Permissions</th>
          <th class="col-actions"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of filtered; trackBy: trackById" class="row-click" (click)="editRole(r.id)">
          <td class="strong">
            {{ r.name }}
            <span class="tag tag-muted br-badge br-badge--neutral" *ngIf="r.isSystemDefault">System</span>
          </td>
          <td class="num muted">{{ r.permissionCount }}</td>
          <td class="col-actions">
            <button type="button" class="icon-btn br-btn br-btn--ghost br-icon-btn" title="Edit" (click)="editRole(r.id); $event.stopPropagation()">
              <br-icon>edit</br-icon>
            </button>
            <button type="button" class="icon-btn danger br-btn br-btn--ghost br-icon-btn" title="Delete"
                    *ngIf="auth.hasPermission('Role.Manage')" (click)="deleteRole(r); $event.stopPropagation()">
              <br-icon>delete_outline</br-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="tc-empty" *ngIf="!loading && !filtered.length">
      <ng-container *ngIf="search">No roles match “{{ search }}”.</ng-container>
      <ng-container *ngIf="!search">No roles yet.</ng-container>
    </div>

    <div class="tc-loading" *ngIf="loading">Loading…</div>
  </div>
</div>
